<template>
  <div class="lis">
    <el-card v-loading='loading'>
      <el-input v-model="input" size="mini" style="width: 105px; margin-right: 10px" placeholder="请输入" clearable></el-input>
      <el-button type="primary" size="mini" @click="search" icon="el-icon-search">搜索</el-button>
      <el-button type="success" size="mini" @click="goProduct">订单商品列表</el-button>
      <el-button type="success" size="mini" @click="trace">追踪订单</el-button>
      <el-button type="success" size="mini" @click="goLog">操作记录</el-button>
      <!-- 选择时间范围 -->
      <div class="block">
        <el-date-picker
          :default-time="['00:00:00','23:59:59']"
          size="mini"
          style="width:320px;margin-left:200px"
          value-format="yyyy-MM-dd HH:mm:ss"
          v-model="value1"
          type="datetimerange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期">
        </el-date-picker>
      </div>
      <!-- 选择站点 -->
      <el-select size="mini" style="margin-left: 10px" v-model="selectSite" multiple placeholder="请选择站点">
        <el-option
          v-for="item in Site"
          :key="item.value"
          :label="item.label"
          :value="item.value">
        </el-option>
      </el-select>
      <!-- 选择订单状态 -->
      <el-select size="mini" style="margin-left: 10px" v-model="selectListStatus" multiple placeholder="请选择订单状态">
        <el-option
          v-for="item in ListStatus"
          :key="item.value"
          :label="item.label"
          :value="item.value">
        </el-option>
      </el-select>
      <el-button size="mini" type="primary" icon="el-icon-search" @click="CXDD" style="margin-left: 10px">查询订单</el-button>
      <el-button size="mini" type="primary" icon='el-icon-circle-plus' @click="BuDan">补单</el-button>
      <el-button size="mini" type="primary">今日订单量：{{count}}</el-button>
      <!-- 补单对话框 -->
      <el-dialog title="补单信息" :visible.sync="dialogFormVisible" width="20%">
        <el-form :model="form">
          <el-form-item label="站点" :label-width="formLabelWidth">
            <el-select v-model="form.site" placeholder="请选择站点">
              <el-option label="madrid-shop" value="madrid-shop"></el-option>
              <el-option label="cuirz" value="cuirz"></el-option>
              <el-option label="nihonbro" value="nihonbro"></el-option>
              <el-option label="jleague-shop" value="jleague-shop"></el-option>
              <el-option label="supermaillot" value="supermaillot"></el-option>
              <el-option label="fortmaillot" value="fortmaillot"></el-option>
              <el-option label="kickitshirts" value="kickitshirts"></el-option>
              <el-option label="mailloten" value="mailloten"></el-option>
              <el-option label="honorjersey" value="honorjersey"></el-option>
              <el-option label="ligafoot" value="ligafoot"></el-option>
              <el-option label="beazl" value="beazl"></el-option>
              <el-option label="top-w" value="top-w"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="订单号" :label-width="formLabelWidth">
            <el-input style="width:215px" v-model="form.ID_" autocomplete="off" placeholder="请输入订单号"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogFormVisible = false">取 消</el-button>
          <el-button type="primary" @click="QD_budan">确 定</el-button>
        </div>
      </el-dialog>
      <!-- 页面表格 -->
      <el-table
        :row-class-name="tableRowClassName"
        height="690"
        :cell-style="{padding:1,borderColor:'#000000'}"
        :header-cell-style="{borderColor:'#000000',color:'#0099ff'}"
        :data="tableData"
        border
        fit
        highlight-current-row
        style="border: 1px solid #000000;width:100%"
        :default-sort = "{prop: 'date_created_gmt', order: 'descending'}"
        >
        <!-- 站点 -->
        <el-table-column
          prop="site"
          width="110px"
          label="站点"
          align="center"
          >
        </el-table-column>
        <!-- 订单id -->
        <el-table-column
          width="90px"
          prop="ID_"
          label="订单id"
          align="center"
        ></el-table-column>
        <!-- 订单状态 -->
        <el-table-column
          width="100px"
          prop="status"
          label="订单状态"
          align="center"
          >
          <template slot-scope="scope">
            <el-tag
            :type="scope.row.status === '待付款' ? 'warning' : (scope.row.status === '正在处理' ? 'primary' : (scope.row.status === '已取消' ? 'info' : (scope.row.status === '已完成' ? 'success' : (scope.row.status === '失败订单' ? 'danger' : 'text'))))"
            disable-transitions>
              {{scope.row.status}}
            </el-tag>
          </template>
        </el-table-column>
        <!-- 下单时间 -->
        <el-table-column
          width="160px"
          prop="date_created_gmt"
          label="下单时间"
          align="center"
          sortable>
        </el-table-column>
        <!-- 付款时间 -->
        <el-table-column
          width="160px"
          prop="date_paid_gmt"
          label="付款时间"
          align="center"
          sortable>
        </el-table-column>
        <!-- 姓名 -->
        <el-table-column
          width="230px"
          property="name"
          label="姓名"
          align="center">
        </el-table-column>
        <!-- 邮箱 -->
        <el-table-column
          width="300px"
          property="email"
          label="邮箱"
          align="center">
        </el-table-column>
        <!-- 手机号 -->
        <el-table-column
          width="130px"
          prop="phone"
          label="手机号"
          align="center">
        </el-table-column>
        <!-- 订单总额 -->
        <el-table-column
          width="100px"
          prop="total"
          label="订单总额"
          align="center">
        </el-table-column>
        <!-- 运输方式 -->
        <el-table-column
          width="90px"
          prop="shiptype"
          label="运输方式"
          align="center">
        </el-table-column>
        <!-- 客户备注 -->
        <el-table-column
          prop="customer_note"
          label="客户备注"
          align="center">
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="pss"
        :page-size="ps"
        :total="Total"
        layout="total, sizes, prev, pager, next, jumper"
        style="display:flex; justify-content: center;">
      </el-pagination>
    </el-card>
    
    <!-- size-change	pageSize 改变时会触发	每页条数 -->
    <!-- current-change	currentPage 改变时会触发	当前页 -->
    <!-- current-page	当前页数，支持 .sync 修饰符	number	—	1 -->
    <!-- page-sizes	每页显示个数选择器的选项设置	number[]	—	[10, 20, 30, 40, 50, 100] -->
    <!-- page-size	每页显示条目个数，支持 .sync 修饰符	number	—	10 -->
    <!-- layout	组件布局，子组件名用逗号分隔	String	sizes, prev, pager, next, jumper, ->, total, slot	'prev, pager, next, jumper, ->, total' -->
    <!-- total	总条目数	number	—	— -->

  </div>
</template>

<script>
import { getOrderPage,getOrder_,BD_,hqzzcl } from "../../api/api"
export default {
  data() {
    return {
      // 每日订单数量
      count:0,
      // 控制补单对话框的显示或隐藏
      dialogFormVisible:false,
      // 补单参数
      form:{
        site:'',
        ID_:''
      },
      // 补单对话框参数标题宽度
      formLabelWidth: '70px',
      // 所有站点
      Site:[{ label: 'madrid-shop', value: 'madrid-shop' }, { label: 'cuirz', value: 'cuirz' }, { label: 'nihonbro', value: 'nihonbro' }, { label: 'jleague-shop', value: 'jleague-shop' }, { label: 'supermaillot', value: 'supermaillot' }, { label: 'fortmaillot', value: 'fortmaillot' }, { label: 'kickitshirts', value: 'kickitshirts' }, { label: 'mailloten', value: 'mailloten' }, { label: 'honorjersey', value: 'honorjersey' }, { label: 'ligafoot', value: 'ligafoot' }, { label: 'beazl', value: 'beazl' }, { label: 'top-w', value: 'top-w' }],
      // 默认筛选站点
      selectSite:[],
      // 所有订单状态
      ListStatus:[{ label: '待付款', value: '待付款' }, { label: '正在处理', value: '正在处理' }, { label: '保留', value: '保留' }, { label: '已完成', value: '已完成' }, { label: '已取消', value: '已取消' }, { label: '已退款', value: '已退款' }, { label: '失败订单', value: '失败订单' }],
      // 默认筛选订单状态
      selectListStatus:['正在处理'],
      // 时间范围值
      value1: [],
      // 页面订单列表数据
      tableData: [],
      // 加载动画
      loading: true,
      // 搜索输入框的值
      input: "",
      // Data_:[],
      // init_: 0,
      // 默认第几页
      currentPage: 1,
      // 页面表格默认条数选择范围
      pss:[100,200,500,700,1000],
      // 默认每页条数
      ps:500,
      // 页面订单搜索计算后的总条数
      Total:0
    };
  },
  created() {

    // 判断账号密码是否过期
    var un = window.localStorage.getItem('un');
    if(un == '' || un == null || un == undefined){
      this.loading = true;
      this.$message.error('账号密码过期，请重新登录！！！');
      return false;
    }

    var params = {
      Site:this.selectSite,
      ListStatus:this.selectListStatus,
      date_created_gmt:this.value1
    }
    // 根据传入参数，获取页面订单总条数
    getOrderPage(params).then(res => {
      this.Total = res.length;
    })
      
    var params = {
      Limit:this.ps,
      Offset:0,
      Site:this.selectSite,
      ListStatus:this.selectListStatus,
      date_created_gmt:this.value1
    }
    // 根据传入参数，获取页面所有订单信息
    getOrder_(params).then(res => {
      this.tableData = res;
      this.loading = false;
    })

    // 获取每日订单数量
    hqzzcl().then(res => {
      var startTime = new Date(new Date(new Date().toLocaleDateString()).getTime());
      var endTime = new Date(new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1);
      var sT = startTime.getTime();
      var eT = endTime.getTime();
      var array = [];
      for(var i of res){
        array.push(new Date(i.date_paid_gmt).getTime());
      }
      for(var i of array){
        if(i >= sT && i <= eT){
          this.count += 1;
        }
      }
    })

  },
  methods: {

    // 设置表格行高亮
    tableRowClassName({row,rowIndex}){
      if(rowIndex % 2 === 1){
        return "yellow"
      }else if(rowIndex % 2 === 0){
        return "red"
      }
    },

    // 查看操作记录
    goLog(){
      const log_ = this.$router.resolve({ path: "/home/log" });
      window.open(log_.href, '_blank');
    },

    // 补单
    BuDan(){
      this.dialogFormVisible = true;
    },

    // 确定补单
    QD_budan(){
      this.dialogFormVisible = false;
      BD_(this.form).then(res => {
        console.log(res);
      })
    },

    //设置每页几条
    handleSizeChange(val) {
      this.loading = true;
      this.ps = val;
      var limit = val;
      var offset = (this.currentPage - 1) * val;
      var params = {
        Limit:limit,
        Offset:offset,
        Site:this.selectSite,
        ListStatus:this.selectListStatus,
        date_created_gmt:this.value1
      }
      getOrder_(params).then(res => {
        this.tableData = res;
        this.loading = false;
      })
    },

    //前往第几页
    handleCurrentChange(val) {
      this.loading = true;
      this.currentPage = val;
      var limit = this.ps;
      var offset = (val - 1) * this.ps;
      var params = {
        Limit:limit,
        Offset:offset,
        Site:this.selectSite,
        ListStatus:this.selectListStatus,
        date_created_gmt:this.value1
      }
      getOrder_(params).then(res => {
        this.tableData = res;
        this.loading = false;
      })
    },

    // 查询订单
    CXDD(){
      this.loading = true;
      var params = {
        Limit:this.ps,
        Offset:(this.currentPage - 1) * this.ps,
        Site:this.selectSite,
        ListStatus:this.selectListStatus,
        date_created_gmt:this.value1
      }
      getOrder_(params).then(res => {
        this.tableData = res;
        this.loading = false;
      })
      var params = {
        Site:this.selectSite,
        ListStatus:this.selectListStatus,
        date_created_gmt:this.value1
      }
      getOrderPage(params).then(res => {
        this.Total = res.length;
      })
    },

    //商品列表
    goProduct(){
      const product_ = this.$router.resolve({path: "/home/productlist"});
      window.open(product_.href, '_blank');
    },

    //追踪订单
    trace(){
      const trace_ = this.$router.resolve({path:"/home/trace"});
      window.open(trace_.href, '_blank');
    },

    //搜索
    search(){
      if(this.input === '' || this.input === null || this.input === undefined){
        this.$message({
          message: '搜索内容为空！！！',
          type: 'error'
        });
        return false;
      }
      const search_ = this.$router.resolve({ path: "/home/search", query: { id: this.input}});
      window.open(search_.href, '_blank');
    }

  }
};

</script>

<style lang="scss" scoped>

/deep/ .el-table .yellow{
  background: #c7e2ff;
  color: #000000;
  &:hover .el-table__cell{
    background: #c7e2ff;
    font-weight: bolder;
  }
}

/deep/ .el-table .red{
  color: #000000;
  &:hover .el-table__cell{
    font-weight: bolder;
  }
}

.block{
  margin-left: 10px;
  display: inline-block;
}
.el-table {
  margin-top: 20px;
  text-align: center;
}
.list{
  display: flex;
  flex-direction: column;
  align-items: center;
}
.btn{
  margin-top: 10px;
}
.deb{
  display: inline-block;
  margin-left: 10px;
}
// 隐藏数字输入框后面的按钮
/deep/ input::-webkit-outer-spin-button,
/deep/ input::-webkit-inner-spin-button {
  -webkit-appearance: none !important;
  appearance: none !important;
}
/deep/ input[type="number"] {
  -moz-appearance: textfield !important;
  appearance: textfield !important;
}
// 对话框
.pub_dialog {
  display: flex;
  justify-content: center;
  align-items: Center;
  overflow: hidden;
  .el-dialog {
    margin: 0 auto !important;
    height: 90%;
    overflow: hidden;
    .el-dialog__body {
      position: absolute;
      left: 0;
      top: 54px;
      bottom: 0;
      right: 0;
      padding: 10px 0 10px 0;
      z-index: 1;
      overflow: hidden;
      overflow-y: auto;
    }
  }
}

// 滚动条的宽度
/deep/ .el-table__body-wrapper::-webkit-scrollbar {
width: 16px; // 横向滚动条
height: 6px; // 纵向滚动条 必写
}
// 滚动条的滑块
/deep/ .el-table__body-wrapper::-webkit-scrollbar-thumb {
background-color: #409eff;
border-radius: 10px;
}
</style>